<template>
  <div
    itemscope
    itemtype="http://schema.org/Product"
    class="perfume-full-view"
    :class="{ minified, onlyquad }"
  >
    <!-- <div class="floating-buttons">
      <div v-if="!isMobile" class="share-button" @click="showShare=data"></div>
      <ShareComponent v-if="!isMobile" :data="data"></ShareComponent>
      <div v-if="!isMobile && showClose" class="separator"></div>
    </div> -->
    <div
      v-if="(isMobile && minified)"
      class="header is-mobile-and-minified"
    >
      <div
        class="image"
        :style="{ backgroundImage: `url(${data.imageUrl})` }"
      ></div>
      <div class="name-and-brand" :class="{ showClose }">
        <div itemprop="name" class="name" :class="nameSizeClass(data.name)">
          {{ perfumeCapitalize(data.name) }}
        </div>
        <div itemprop="brand" class="brand">{{ data.brand.name }}</div>
        <FamiliesWithIcon
          itemprop="additionalProperty"
          v-if="minified"
          :family="data.family"
          :subfamily="data.secondaryFamily"
        ></FamiliesWithIcon>
      </div>
    </div>
    <div v-else-if="isMobile && onlyquad" class="header is-mobile-and-onlyquad">
      <div class="quad-header">
        <div class="name-and-brand">
          <div itemprop="name" class="name" :class="nameSizeClass(data.name)">
            {{ perfumeCapitalize(data.name) }}
          </div>
          <div class="brand-and-fam">
            <div itemprop="brand" class="brand">{{ data.brand.name }}</div>
            <FamiliesWithIcon
              itemprop="additionalProperty"
              :family="data.family"
              :subfamily="data.secondaryFamily"
            ></FamiliesWithIcon>
          </div>
        </div>
      </div>
      <div class="quad-content">
        <div class="left">
          <div
            class="image"
            :style="{ backgroundImage: `url(${data.imageUrl})` }"
          ></div>
          <!-- <AddToFavsButton :data="data"></AddToFavsButton> -->
          <!-- <div class="share-button" @click="showShare=data"></div> -->
          <!-- <ShareComponent :data="data"></ShareComponent> -->
        </div>
        <QuadPack
          :proportions="data.ingredientProportions"
          :heroIngredient="data.heroIngredient"
        ></QuadPack>
      </div>
    </div>
    <div v-else-if="isMobile" class="header is-mobile">
      <div class="name-and-brand">
        <div itemprop="name" class="name" :class="nameSizeClass(data.name)">
          {{ perfumeCapitalize(data.name) }}
        </div>
        <div class="brand-and-fam">
          <div itemprop="brand" class="brand">{{ data.brand.name }}</div>
          <FamiliesWithIcon
            itemprop="additionalProperty"
            :family="data.family"
            :subfamily="data.secondaryFamily"
          ></FamiliesWithIcon>
        </div>
        <div
          v-if="showClose"
          class="close-button"
          @click="$emit('close')"
        ></div>
      </div>
    </div>
    <div v-else class="header" ref="subsection0" :style="forcedHeigh(0)">
      <div class="name-and-brand">
        <div itemprop="name" class="name" :class="nameSizeClass(data.name)">
          {{ perfumeCapitalize(data.name) }}
        </div>
        <div itemprop="brand" class="brand">{{ data.brand.name }}</div>
      </div>
      <div v-if="showClose" class="close-button" @click="$emit('close')"></div>
    </div>
    <div
      v-if="!minified && !onlyquad"
      class="subsection main"
      ref="subsection1"
      :style="forcedHeigh(1)"
    >
      <div class="left" v-if="!tabletFormat">
        <!-- <div class="family-with-icon">{{data.family.name}}</div> -->
        <FamiliesWithIcon
          itemprop="additionalProperty"
          v-if="!isMobile"
          :family="data.family"
          :subfamily="data.secondaryFamily"
        ></FamiliesWithIcon>
        <div class="image-wrapper">
          <div
            class="image"
            :style="{ backgroundImage: `url(${data.imageUrl})` }"
          ></div>
        </div>
        <!-- <AddToFavsButton :data="data"></AddToFavsButton> -->
        <!-- <div v-if="isMobile" class="share-button" @click="showShare=data"></div> -->
        <!-- <ShareComponent v-if="isMobile" :data="data"></ShareComponent> -->
      </div>
      <div class="right">
        <div v-if="data.expertReviewed" class="expert-reviewed">
          <div class="icon"></div>
          <div class="text">{{ t("expert_reviewed") }}</div>
        </div>
        <QuadPack
          :proportions="data.ingredientProportions"
          :heroIngredient="data.heroIngredient"
        ></QuadPack>
      </div>
    </div>

    <div
      v-if="!minified && !onlyquad"
      class="subsection ingredients"
      ref="subsection2"
      :style="forcedHeigh(2)"
      itemprop="additionalProperty"
      itemscope
      itemtype="http://schema.org/PropertyValue"
    >
      <div itemprop="name" class="subsection-title">{{ t("ingredients") }}</div>
      <div class="subsection-content ingredients-list">
        <div
          itemprop="value"
          v-for="ingredient in data.ingredientProportions"
          :key="ingredient.id"
          class="ingredient-item"
        >
          {{ ingredient.ingredient.name }}
        </div>
      </div>
    </div>

    <!-- De momento nada... -->
    <!-- <div v-if="showRecoReason && !minified && !onlyquad" class="subsection reco-reason">
      <div class="subsection-title">{{t('reco_desc_title')}}</div>
      <div class="subsection-content">
        <RecoDesc :data="data"></RecoDesc>
      </div>
    </div> -->

    <div
      v-if="!minified && !onlyquad"
      class="subsection description"
      ref="subsection3"
      :style="forcedHeigh(3)"
    >
      <div class="subsection-title">{{ t("description") }}</div>
      <div itemprop="description" class="subsection-content">
        {{ data.description }}
      </div>
    </div>
    <div
      v-if="!minified && !onlyquad"
      class="subsection family"
      ref="subsection4"
      :style="forcedHeigh(4)"
    >
      <FamilyDonut
        :family="data.family"
        :subfamily="data.secondaryFamily"
      ></FamilyDonut>
      <div class="family-desc">
        <div class="subsection-title">{{ t("olfactive_family") }}</div>
        <div class="subsection-content">
          <div
            itemprop="additionalProperty"
            itemscope
            itemtype="http://schema.org/PropertyValue"
            class="fam-group"
          >
            <div itemprop="name" class="title uppercase">
              {{ t("main_family") }}
            </div>
            <div itemprop="value" class="value">{{ data.family.name }}</div>
          </div>
          <div
            itemprop="additionalProperty"
            itemscope
            itemtype="http://schema.org/PropertyValue"
            class="fam-group"
            v-if="data.secondaryFamily"
          >
            <div itemprop="name" class="title uppercase">
              {{ t("sub_family") }}
            </div>
            <div itemprop="value" class="value">
              {{ data.secondaryFamily.name }}
            </div>
          </div>
          <div
            itemprop="additionalProperty"
            itemscope
            itemtype="http://schema.org/PropertyValue"
            class="fam-group"
            v-if="data.meFamilyName"
          >
            <div itemprop="name" class="title">{{ t("me_family") }}</div>
            <div itemprop="value" class="value">{{ data.meFamilyName }}</div>
          </div>
        </div>
      </div>
    </div>

    <div
      itemprop="additionalProperty"
      itemscope
      itemtype="http://schema.org/PropertyValue"
      v-if="!minified && !onlyquad"
      class="subsection perfumist"
      :class="canHide(5) && !data.perfumer ? 'hidden' : ''"
      ref="subsection5"
      :style="forcedHeigh(5)"
    >
      <template v-if="data.perfumer">
        <div itemprop="name" class="subsection-title">{{ t("perfumist") }}</div>
        <div itemprop="value" class="subsection-content">
          {{ data.perfumer }}
        </div>
      </template>
    </div>
    <!-- REMOVED CONCEPTS UNTIL WE GET THE DATA...  -->
    <!-- <div
      v-if="!minified && !onlyquad"
      class="subsection concepts"
      ref="subsection6"
      :style="forcedHeigh(6)"
    >
      <div class="subsection-title">{{t('concepts')}}</div>
      <div class="subsection-content">
        <div class="concepts-list">
          <ConceptTag color="white" :data="{label: 'fake-concept'}" :showRemove="false"></ConceptTag>
          <ConceptTag color="white" :data="{label: 'fake-concept-2'}" :showRemove="false"></ConceptTag>
          <ConceptTag color="white" :data="{label: 'other-fake'}" :showRemove="false"></ConceptTag>
        </div>
      </div>
    </div>-->

    <div class="similar-button-wrapper" v-if="canShowSimilar">
      <SquareButton @click="$emit('show-similar')">{{
        t("show_similar")
      }}</SquareButton>
    </div>
  </div>
</template>

<script>
import { QuadPack } from "@bestiario/puig-quad-pack";
import FamiliesWithIcon from "@/components/wikiparfum/FamiliesWithIcon";
// import AddToFavsButton from '@/components/wikiparfum/AddToFavsButton'
import SquareButton from "@/components/wikiparfum/SquareButton";
import FamilyDonut from "@/components/wikiparfum/FamilyDonut";
import NameSizeClasses from "@/vue-plugins/NameSizeClasses";
// import ShareComponent from '@/components/ShareComponent'
// import {trackPerfumViewed} from '@/services/track'
// import RecoDesc from '@/components/wikiparfum/Profile/RecoDesc'
// import ConceptTag from '@/components/ConceptTag'
export default {
  name: "PerfumeFullView",
  components: {
    QuadPack,
    FamiliesWithIcon,
    // AddToFavsButton,
    SquareButton,
    FamilyDonut
    // RecoDesc,
    // ShareComponent

    // ConceptTag
  },
  mixins: [NameSizeClasses],
  props: {
    data: Object,
    canShowSimilar: {
      type: Boolean,
      default: false
    },
    forcedHeights: Array,
    minified: {
      type: Boolean,
      default: false
    },
    onlyquad: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true
    },
    tabletFormat: {
      type: Boolean,
      default: false
    },
    showRecoReason: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ownHeights: null
      // showShare: null
    };
  },
  // routerLinkedData:['showShare'],
  methods: {
    forcedHeigh(index) {
      // if(this.forcedHeights) return {height: this.forcedHeights[index]+'px'}
      // // else if(this.ownHeights) return {height: this.ownHeights[index]+'px'}
      // else return {height: 'auto'}
      let forcedHeight = this.forcedHeights && this.forcedHeights[index];
      return { height: forcedHeight ? forcedHeight + "px" : "auto" };
    },
    canHide(index) {
      if (this.forcedHeights && this.forcedHeights[index]) return false;
      else return true;
    },
    getHeights() {
      // LIMPIARLO PERO PARECE QEU "IS THE WAY", quitar->medir->reponer
      let idxs = [0, 1, 2, 3, 4, 5, 6];
      let currentsStyles = [];
      idxs.forEach(i => {
        if (this.$refs["subsection" + i]) {
          currentsStyles[i] = this.$refs["subsection" + i].style.height;
          this.$refs["subsection" + i].style.height = "auto";
        }
      });

      this.ownHeights = idxs.map(i => {
        return (
          this.$refs["subsection" + i] &&
          this.$refs["subsection" + i].offsetHeight
        );
      });

      idxs.forEach(i => {
        if (currentsStyles[i])
          this.$refs["subsection" + i].style.height = currentsStyles[i];
      });
      if (!this.data.perfumer) this.ownHeights[5] = null;
      return this.ownHeights;
    }
  },
  mounted() {
    // trackPerfumViewed({id:this.data.id})
    this.$nextTick(() => {
      this.$emit("update");
    });
  },
  watch: {
    data() {
      this.$nextTick(() => {
        this.$emit("update");
      });
    }
  }
};
</script>

<style scoped lang="stylus">
$similar-button-wrapper-height = vh(100px)

.perfume-full-view
  background-color: #fff
  margin: auto
  padding: vw(20px)
  padding-bottom: vw(50px) // por el boton flotante - no se si debe ir "siempre o no"
  pointer-events: all
  position: relative
  width: 100%

  .mobile &
    padding: vw(40px)
    padding-bottom: $similar-button-wrapper-height

    @media (max-width: 375px)
      padding: vw(40px)

  &.minified
    padding-bottom: 0

  &.onlyquad
    height: 100%
    padding-bottom: vh(10px)

  .floating-buttons
    align-items: center
    display: flex
    position: absolute
    right: vw(20px)
    top: vh(20px)

    .tablet &
      top: vh(10px)

    .mobile &
      right: vw(12px)

    .separator
      background-color: rgba(#000, 0.15)
      height: vh(25px)
      margin: 0 vw(15px)
      width: 1px

  .close-button
    m-icon("close", 70)
    cursor: pointer
    position: absolute
    right: 0
    top: 0

    .mobile &
      @media (max-width: 375px)
        m-icon("close", 100)

  .header
    height: vw(100px) !important
    margin-bottom: vw(40px)
    margin-left: auto
    margin-right: auto
    max-width: 1024px
    position: relative
    text-align: center

    &.is-mobile
      border-bottom: none

    &.is-mobile,
    &.is-mobile-and-onlyquad
      display: flex
      overflow: hidden
      padding: 0

      @media (max-width: 768px)
        height: auto !important

      @media (max-width: 375px)
        margin-bottom: 0

      .name-and-brand
        align-items: flex-start
        display: flex
        flex-direction: column
        margin-bottom: vh(10px)
        overflow: hidden
        width: 100%

        .brand-and-fam
          align-items: center
          display: flex
          overflow: hidden
          width: 100%

          .name
            margin-right: vw(80px)
            text-align: left

          .brand
            margin-right: vw(10px)
            max-width: 50%
            padding-right: vw(10px)
            position: relative

            @media (max-width: 375px)
              margin-right: vw(30px)
              padding-right: vw(30px)

            &:after
              background-color: rgba(#000, 0.15)
              content: ""
              height: 100%
              position: absolute
              right: 0
              top: 0
              width: 1px

          >>> .family-and-icon
            flex: 1 1 0%
            height: vw(35px)
            overflow: hidden

            @media (max-width: 375px)
              height: vw(70px)

            .icon
              margin-left: vw(5px)
              margin-right: vw(15px)

              @media (max-width: 375px)
                margin-left: vw(25px)
                margin-right: vw(35px)

            .label
              display: block

    &.is-mobile-and-minified
      display: flex
      margin: 0
      padding: 0
      padding-bottom: vh(20px)

      .image
        flex: 0 0 vw(70px) // ALGO ASI...
        margin: 0

      .name-and-brand
        align-items: flex-start
        overflow: hidden

        &.showClose
          padding-right: vw(90px)

        .name
          m-ellipsis(100%)

        .brand
          margin-bottom: vh(5px)

        >>> .family-and-icon
          margin-top: vw(5px)

          .icon
            margin-right: vh(4px)

    &.is-mobile-and-onlyquad
      display: flex
      flex-direction: column
      // padding: 0
      height: 100%
      padding-bottom: vh(20px)
      width: 100%

      .similar-perfumes-wrapper &
        border-bottom: none
        padding-bottom: 0

        .name
          margin-right: vw(40px)

      .quad-header
        display: flex
        margin-bottom: vh(10px)

        // flex: 0 0 auto
        .name-and-brand
          align-items: flex-start
          display: flex
          flex-direction: column

          .name
            text-align: left
            m-ellipsis(100%)

          .brand-and-fam
            display: flex

      .quad-content
        display: flex
        flex: 1 1 0%

        .left
          align-items: center
          display: flex
          flex: 0 0 25%
          flex-direction: column
          justify-content: space-evenly

          .image-wrapper
            height: 100%
            padding: vh(40px) vw(40px)
            width: 100%

            .image
              height: 36vh
              margin: vw(20px)
              width: 100%

          >>> .add-to-favs-button
            margin: vh(10px) auto

            .icon
              m-icon("add", 20)
              margin-bottom: 0

              &.faved
                m-icon("remove", 20)

            .label
              display: none

          >>> .share-component
            .share-panel
              bottom: "calc(100% + %s)" % vh(12px)
              left: vh(-6px)
              right: inherit
              top: inherit

        .quad-pack
          flex: 1 1 0%

    .image
      background-position: center
      background-repeat: no-repeat
      background-size: contain
      flex: 1 1 0%
      margin: vh(20px) 0
      width: 90%

    .name-and-brand
      align-items: center
      display: flex
      flex-direction: column
      height: 100%
      justify-content: space-between

      .mobile &
        margin-right: vw(30px)
        margin-right: vw(100px)
        overflow: hidden
        padding: vw(10px)

      .name
        m-font-size(24, 32)
        margin-bottom: vh(5px)

        .mobile &
          m-font-size(24, 32) // no esta bien, porque si el nombre es largo "se sale..."
          padding-right: vw(40px)
          text-align: left

      .brand
        m-ellipsis(100%)
        m-font-size(14, 17)
        m-letter-spacing(16)
        text-transform: uppercase

        .mobile &
          m-font-size(14, 16)

          @media (max-width: 375px)
            m-font-size(16, 20)

  .similar-button-wrapper
    bottom: vw(10px)
    display: flex
    justify-content: center
    left: 10%
    position: fixed
    width: 80%
    z-index: 1

    .square-button
      margin-bottom: vh(10px)
      z-index: 1

      .mobile &
        height: $similar-button-wrapper-height
        margin: 0
        // chapuzilla para qeu "FINd PERFUMES WITH SIMILAR INGREDIENTS" salga 1-liner
        padding: 0
        width: 100%

  .subsection
    border-bottom: 1px solid rgba(#000, 0.15)
    margin-bottom: vw(20px)
    margin-left: auto
    margin-right: auto
    margin-top: vw(20px)
    max-width: 1024px
    padding-bottom: vh(20px)
    padding-left: vw(15px)
    padding-right: vw(15px)
    transition: height 0.4s

    .mobile &
      margin-bottom: vw(30px)
      margin-top: vw(30px)
      padding-bottom: vw(30px)

      @media (max-width: 375px)
        margin-bottom: vw(40px)
        margin-top: vw(40px)

    &.hidden
      border: none
      height: auto
      margin: 0
      padding: 0

    &.main
      border-top: 1px solid rgba(#000, 0.15)
      display: flex
      margin-bottom: vw(20px)
      margin-top: 0
      overflow: hidden
      padding: 0

      .mobile &
        margin-bottom: vw(40px)

        @media (max-width: 768px)
          display: block

        .left,
        .right
          border: none
          max-width: none

        .left
          position: relative

          .image
            flex: 0 0 36vh !important
            height: 36vh !important

          .share-component
            bottom: 0
            bottom: vh(10px)
            margin: vh(20px)
            margin: 0
            position: absolute
            right: 0

            >>> .share-panel
              bottom: "calc(100% + %s)" % vh(18px)
              left: inherit
              right: vh(4px)
              top: inherit

        .right
          @media (max-width: 768px)
            margin: 0 auto
            max-width: 50%

          @media (max-width: 500px)
            max-width: 100%

          .expert-reviewed
            border-top: 1px solid rgba(#000, 0.15)
            justify-content: flex-start
            margin-bottom: vh(20px)
            margin-top: vh(20px)
            padding-top: vh(20px)

      .left,
      .right
        padding: vh(10px) vw(20px)

        .mobile &
          padding: vh(10px) 0

      // NO ME GUSTA NADA AQUI,
      // .half-size &
      // .left
      // transition flex 1.4s
      // flex: 0 0 auto

      // .right
      // transition flex 1.4s
      // flex: 1 1 0
      .left
        border-right: 1px solid rgba(#000, 0.15)
        display: flex
        flex: 0 0 50%
        flex-direction: column

        .family-and-icon
          >>>.label
            white-space: normal

        .image-wrapper
          height: 100%
          padding: 2vw
          width: 100%

          .image
            background-position: center
            background-repeat: no-repeat
            background-size: contain
            flex: 1 1 vh(100px)
            height: 100%
            margin: vh(10px) 0
            width: 100%

      .right
        display: flex
        flex: 0 0 50%
        flex-direction: column
        justify-content: center

        // max-width: 50vh
        .expert-reviewed
          align-items: center
          display: flex
          justify-content: flex-end
          margin-bottom: vh(20px)

          .icon
            m-icon("expert-reviewed", 18)
            margin-right: vw(5px)

          .text
            m-first-letter-case()
            m-font-size(11, 13)

    .subsection-title
      font-weight: $fw-bold
      m-first-letter-case()
      m-font-size(11, 13)
      margin-bottom: vh(20px)
      text-align: left

      // text-transform: uppercase
      .mobile &
        m-font-size(15, 17)

    .subsection-content
      m-font-size(14, 24)
      m-letter-spacing(25)
      text-align: left

  .subsection
    &.main
      .mobile &
        border: none

    &.ingredients
      .ingredients-list
        display: flex
        flex-wrap: wrap
        margin-left: vw(-10px)
        margin-right: vw(-10px)

        .ingredient-item
          margin: vw(5px) vw(10px)

          &:not(:last-child)
            position: relative

            &:after
              background: rgba(#000, 0.15)
              content: ""
              height: 100%
              position: absolute
              right: vw(-10px)
              top: 0
              width: 1px

    &.family
      align-items: center
      display: flex
      flex-direction: row

      .family-donut
        flex: 0 0 vw(100px)
        height: vw(100px)
        margin-right: vw(40px)
        width: vw(100px)

      .family-desc
        .subsection-content
          display: flex
          flex-wrap: wrap

          .fam-group
            margin: vh(5px) 0

            &:not(:last-child)
              margin-right: vw(40px)

            .title
              m-font-size(11, 13)
              margin-bottom: vh(5px)
              opacity: 0.5

    &.concepts
      .concepts-list
        display: flex
        flex-wrap: wrap
        margin: vh(-5px) vw(-5px)

        .concept-tag
          margin: vh(5px) vw(5px)
</style>